import {Notification} from '../../models';
import {API} from '../types';

type Params = {
  id: number;
  title: string;
  body?: string;
  scheduledAt: string;
  skillIds?: number[];
  districtNumbers?: number[];
  additionalInfo?: string;
  image?: File | string;
};

interface Response {
  notification: Notification;
}

export function editNotificationAPI(params: Params): API<Response> {
  const formData = new FormData();
  Object.keys(params).forEach(key => {
    if (key !== 'id') {
      const value = params[key as keyof Omit<Params, 'id'>]!;
      formData.append(key, Array.isArray(value) ? value.join(',') : value);
    }
  });

  return {
    getData: async client => {
      const {data} = await client({
        url: `/notifications/${params.id}`,
        method: 'PUT',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return {data: {notification: data}};
    },
    getMockData: () => {
      return {
        notification: {
          id: 1,
          title: 'string',
          createdAt: 'string',
          scheduledAt: '',
          status: 'published',
        },
      };
    },
  };
}
